// src/features/records/services/utils/normalizeRecord.js

export function normalizeRecord(record) {
  if (!record) return null;

  const normalized = { ...record };

  if (!normalized.content || typeof normalized.content !== 'object') {
    normalized.content = {};
  }

  if (normalized.attachmentsSummary) {
    normalized.content.attachmentsSummary = normalized.attachmentsSummary;
  }

  return normalized;
}

export function normalizeRecordSnapshot(snapshot) {
  if (!snapshot?.exists()) {
    return null;
  }

  return normalizeRecord({ id: snapshot.id, ...snapshot.data() });
}
